import { Dialog } from '@/components/UI/Dialog'
import { IconLogin } from '@tabler/icons-react'
import { memo } from 'react'

type Props = {
  /** ダイアログが開いているか */
  opened: boolean
  /** 閉じる時のコールバック */
  onClose: () => void
  /** ログイン・会員登録画面のURL（useCampaignSlug().loginUrl） */
  loginUrl: string
  /** モーダルが開いている間、bodyのスクロールをロックするか。Storybookなど埋め込み環境では false にする（default: true） */
  scrollLock?: boolean
}

/**
 * 非ログイン時に会員登録・ログインへ誘導するダイアログ。
 * スタンプ獲得など、認証が必要な操作をした際に表示する。
 */
export const DialogLoginRequired = memo(({ opened, onClose, loginUrl, scrollLock = true }: Props) => {
  return (
    <Dialog selectorState={opened} compact showCloseButton={false} lockScroll={scrollLock} closeAction={onClose}>
      <div className="flex flex-col items-center gap-[16px] py-[8px]">
        <div className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-[#f5f5f5]">
          <IconLogin size={32} className="text-[#757575]" />
        </div>

        {/* TODO: i18n対応 #2319 */}
        <p className="text-center text-[14px] font-bold text-black leading-[22px]">ログイン後に取得可能です</p>

        <p className="text-center text-[12px] text-gray-500 leading-[18px]">
          会員登録・ログインすると
          <br />
          スタンプを獲得できます
        </p>

        <a
          href={loginUrl}
          className="flex items-center justify-center h-[44px] w-[254px] rounded-[8px] text-[13px] font-bold bg-main text-sub"
        >
          会員登録・ログイン
        </a>

        <button
          type="button"
          onClick={onClose}
          className="h-[36px] w-[254px] rounded-[8px] text-[13px] font-bold bg-white border border-[#757575] text-[#757575]"
        >
          キャンセル
        </button>
      </div>
    </Dialog>
  )
})
